module.exports = __webpack_public_path__ + "static/img/lm-loop-h5.e09967e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lm-loop-h5.png
// module id = fJ0U
// module chunks = 0